<template>
<div class="svg-container-outer">
    <div class="svg-container">
        <loading-charts v-if="loadingData" class="loading-charts"/>
        <div class="table-container-main">
            <div class="responsive-table">
                <div class="table-header" id="header">
                    <div class="col-1">Stop</div>
                    <div class="col-2">Arrival</div>
                    <div class="col-3">Address</div>
                    <div class="col-4">Shipment</div>
                </div>
                <loading-charts v-if="loadingTable" class="loading-charts"/>
                <div class="table-row-container">
                    <div class="table-row" v-for="(shipment, index) in tripShipments" :key="index">
                        <div class="col-1" v-if="shipment?.serviceStatus != 'Error'"><p class="shipmentid-text" id="shipmentid-text">{{shipment.stop}}</p></div>
                        <div class="col-1" v-else><p class="shipmentid-text" style="background-color: red; color: #fff;" id="shipmentid-text">{{shipment.stop}}</p></div>
                        <div class="col-2 col-data">{{ shipment?.arrival
                                        ? formatLocalTimeArrival(shipment.arrival)
                                        : "" }}</div>
                        <div class="col-3 col-data" v-if="shipment.address">{{shipment.address.address1}}, {{shipment.address.city}}, {{shipment.address.state}}, {{shipment.address.zipCode}}</div>
                        <!-- <div class="col-3 col-data"><p class="service-text">{{shipment.status}}</p></div> -->
                        <div class="col-4 col-data" v-if="shipment.shipments && shipment.shipments.length > 0">
                            <div v-for="(shipmentItem, item) in shipment.shipments" :key="item">
                                <div class="shipment-status-container">
                                    <p style="flex-wrap: nowrap;" class="shipmentid-text" @click="trackShipment(shipmentItem.shipmentID)">{{shipmentItem.shipmentID}}</p>
                                    <p class="activity-description">{{shipmentItem?.lastActivity?.description ?? ""}}</p>
                                    <p style="font-size: 12px;">{{ shipmentItem?.lastActivity?.activityTime
                                        ? formatLocalTime(shipmentItem.lastActivity.activityTime)
                                        : "" }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="(tripShipments.length == 0)" class="table-row-container">
                    <div class="table-row">
                        <div class="col-1"><p class="shipmentid-text" id="shipmentid-text"></p></div>
                        <div class="col-2 col-data">No Shipments</div>
                        <div class="col-3 col-data"><p class="service-text"></p></div>
                        <div class="col-4"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="button-container">
            <div class="print-selected close-label">
                <p class="print-selected-text download-csv" @click="downloadCSVTest()">Download CSV</p>
                <p class="print-selected-text download-csv" @click="createStopsPdf()">Download PDF</p>
            </div>
        </div>
    </div>
</div>

<shipment-info v-if="toggleTrackShipment" @closeShipmentInfo="closeShipmentInfo($event)" :trackShipmentID="trackShipmentID" :cognitoUser="cognitoUser" :userData="userData"/>
<alert-user  v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {API} from 'aws-amplify';
import ShipmentInfo from './../ShipmentInfo.vue'
import LoadingCharts from '../../ShipmentDashboard/LoadingCharts.vue'
import AlertUser from '../../Popups/AlertUser.vue';
import jsonexport from 'jsonexport'
import { PDFDocument, StandardFonts } from 'pdf-lib'
import bwipjs from 'bwip-js';

export default {
    components:{
        ShipmentInfo,
        LoadingCharts,
        AlertUser
    },
    props: ['userData', 'cognitoUser', 'filterByTripSheetID'],
    data(){
        return{
            trackShipmentID: null,
            toggleTrackShipment: false,
            user: null,
            loadingData: false,
            loadingTable: false,
            isFiltered: false,
            filterField: '',
            filterValue: '',
            toggleAlertBox: '',
            alertMessage: '',
            tripShipments: []
        }
    },
    mounted(){
        if (this.filterByTripSheetID) {
            let event = {
                filterField: "tripSheetID",
                filterValue: this.filterByTripSheetID
            };

            this.runFilter(event);
        }
    },
    methods:{
        async makePdf417PngBytes(text) {
            const canvas = document.createElement('canvas');
            await bwipjs.toCanvas(canvas, {
                bcid: 'pdf417',
                text: String(text),
                scale: 2,
                height: 10,
                includetext: false,
                columns: 6,
            });

            const blob = await new Promise(res => canvas.toBlob(res, 'image/png'));
            const ab = await blob.arrayBuffer();
            return new Uint8Array(ab);
            },
        async createStopsPdf() {
            let stops = this.tripShipments;
            const sorted = [...stops].sort((a, b) => (a.stop ?? 0) - (b.stop ?? 0));

            // Setup doc + fonts
            const pdf = await PDFDocument.create();
            let page = pdf.addPage();
            const font = await pdf.embedFont(StandardFonts.Helvetica);
            const fontBold = await pdf.embedFont(StandardFonts.HelveticaBold);

            // Layout
            const margin = 50;
            const lineH = 16;
            let y = page.getHeight() - margin;

            // Adds new page as needed
            const line = (text, { bold=false, size=12 } = {}) => {
                if (y < margin + lineH) {
                page = pdf.addPage();
                y = page.getHeight() - margin;
                }
                page.drawText(text, { x: margin, y: y - lineH, size, font: bold ? fontBold : font });
                y -= lineH;
            };

            for (const s of sorted) {
                if(s.waypoint == "*"){
                    const toLocalTime = t => {
                    const [h, m] = t.split(':');
                    const d = new Date();
                        d.setHours(h, m);
                        return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                    };

                    const time = [s.startTime, s.endTime]
                    .filter(Boolean)
                    .map(toLocalTime)
                    .join(' – ');

                    line('LREX ' + s.created + ' Route ' + s.route + ' ( ' + time + ' )', { bold: true, size: 12 });
                    y -= 6;
                }

                if (s.waypoint === "*" && s.totalDistance && s.totalTime) {
                    const totalTime = Number(s.totalTime / 60).toFixed(2);
                    const totalDistance = Number(s.totalDistance).toFixed(2);

                    const timeText = `Total Time: ${totalTime} hours`;
                    const distText = `Total Miles: ${totalDistance}`;
                    const fontSize = 12;

                    // Measure width of right-side text to align it properly
                    const rightTextWidth = font.widthOfTextAtSize(distText, fontSize);

                    // Left side
                    const leftX = margin;
                    const rightX = page.getWidth() - margin - rightTextWidth;

                    page.drawText(timeText, { x: leftX, y: y - lineH, size: fontSize, font });
                    page.drawText(distText, { x: rightX, y: y - lineH, size: fontSize, font });

                    y -= lineH + 6;
                }
                const width = page.getWidth();
                page.drawLine({
                    start: { x: 50, y },
                    end:   { x: width - 50, y },
                    thickness: 1,
                    dashPhase: 0,
                });
                const header = Number.isFinite(s.stop) ? `Stop ${s.stop}` : 'Stop';
                const toLocalTime = t => {
                    const [h, m] = t.split(':');
                    const d = new Date();
                    d.setHours(h, m);
                    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                };

                const time = [s.windowStart, s.windowEnd]
                .filter(Boolean)
                .map(toLocalTime)
                .join(' – ');

                const arrivalTime = [s.arrival]
                .filter(Boolean)
                .map(toLocalTime);
                line(`${header} ${arrivalTime} ${time ? ` (${time})` : ''}`, { bold: true, size: 13 });
                
                console.log("PICKUPS: ", s.pickups)
                if(s.pickups == 1){
                    line("Pickup")
                    if(s.locations && s.locations.length > 0){
                        console.log("LOCATIONS: ", s.locations)
                        for(const loc of s.locations){
                            console.log("LOCATION VALUE", loc)
                            const addr1 = loc.address1 ?? '';
                            const addr2 = loc.address2 ? `, ${loc.address2}` : '';
                            const csz = [loc.city, loc.state, loc.zipCode].filter(Boolean).join(', ');
                            const company = loc.companyName ? `${loc.companyName} — ` : '';
                            y -= 10
                            let addressText = `${company}${addr1}${addr2}${csz ? `, ${csz}` : ''}`;

                            const maxLen = 45;
                            const chunks = [];
                            let text = addressText.trim();
                            page.drawLine({
                                start: { x: 50, y },
                                end:   { x: 390, y },
                                thickness: 1,
                                dashPhase: 0,
                            });
                            while (text.length > maxLen) {
                                // find the last space before the 45th character
                                let splitIndex = text.lastIndexOf(' ', maxLen);

                                if (splitIndex === -1) {
                                splitIndex = maxLen;
                                }

                                chunks.push(text.slice(0, splitIndex).trim());

                                text = text.slice(splitIndex).trim();
                            }

                            if (text.length) chunks.push(text);

                            chunks.forEach(lineText => {
                                line(" " + lineText);
                            });

                            page.drawLine({
                                start: { x: 50, y: y - 5 },
                                end:   { x: 390, y: y - 5},
                                thickness: 1,
                                dashPhase: 0,
                            });

                            page.drawLine({
                                start: { x: 50, y: y - 5},
                                end:   { x: 50, y: y + lineH * chunks.length },
                                thickness: 1,
                                dashPhase: 0,
                            });

                            page.drawLine({
                                start: { x: 390, y: y - 5 },
                                end:   { x: 390, y: y + lineH * chunks.length },
                                thickness: 1,
                                dashPhase: 0,
                            });
                        }
                    }
                    // const a = s?.address ?? {};
                    // const addr1 = a.address1 ?? '';
                    // const addr2 = a.address2 ? `, ${a.address2}` : '';
                    // const csz = [a.city, a.state, a.zipCode].filter(Boolean).join(', ');
                    // const company = a.companyName ? `${a.companyName} — ` : '';
                    // y -= 10
                    // let addressText = `${company}${addr1}${addr2}${csz ? `, ${csz}` : ''}`;

                    // const maxLen = 45;
                    // const chunks = [];
                    // let text = addressText.trim();
                    // page.drawLine({
                    //     start: { x: 50, y },
                    //     end:   { x: 390, y },
                    //     thickness: 1,
                    //     dashPhase: 0,
                    // });
                    // while (text.length > maxLen) {
                    //     // find the last space before the 45th character
                    //     let splitIndex = text.lastIndexOf(' ', maxLen);

                    //     if (splitIndex === -1) {
                    //     splitIndex = maxLen;
                    //     }

                    //     chunks.push(text.slice(0, splitIndex).trim());

                    //     text = text.slice(splitIndex).trim();
                    // }

                    // if (text.length) chunks.push(text);

                    // chunks.forEach(lineText => {
                    //     line(" " + lineText);
                    // });

                    // page.drawLine({
                    //     start: { x: 50, y: y - 5 },
                    //     end:   { x: 390, y: y - 5},
                    //     thickness: 1,
                    //     dashPhase: 0,
                    // });

                    // page.drawLine({
                    //     start: { x: 50, y: y - 5},
                    //     end:   { x: 50, y: y + lineH * chunks.length },
                    //     thickness: 1,
                    //     dashPhase: 0,
                    // });

                    // page.drawLine({
                    //     start: { x: 390, y: y - 5 },
                    //     end:   { x: 390, y: y + lineH * chunks.length },
                    //     thickness: 1,
                    //     dashPhase: 0,
                    // });
                }

                const shipList = Array.isArray(s.shipments) ? s.shipments : [];
                if (shipList.length === 0 && s.pickups == null) {
                    line('Depot ' + s.waypoint);
                    y -= 6;
                    const w = page.getWidth();
                    page.drawLine({
                        start: { x: 50, y },
                        end:   { x: w - 50, y },
                        thickness: 1,
                        dashPhase: 0,
                    });
                    continue;
                }
                
                for (const sh of shipList) {
                    const id = sh?.shipmentID ?? '(no id)';
                    const a = sh?.address ?? {};
                    const addr1 = a.address1 ?? '';
                    const addr2 = a.address2 ? `, ${a.address2}` : '';
                    const csz = [a.city, a.state, a.zipCode].filter(Boolean).join(', ');
                    const company = a.companyName ? `${a.companyName} — ` : '';

                    const textTopY = y;
                    line(`Shipment ID:  ${id}`);
                    if(sh.signatureRequired){
                        page.drawText("Signature Required", {
                        x: 425,
                        y: y,
                        size: 10,
                        font: fontBold
                        });
                        y -= 10
                    }

                    if(sh.isPriority){
                        page.drawText("Priority", {
                        x: 425,
                        y: y,
                        size: 10,
                        font: fontBold
                        });
                        y -= 10
                    }
                    
                    y -= 10
                    let addressText = `${company}${addr1}${addr2}${csz ? `, ${csz}` : ''}`;

                    const maxLen = 45;
                    const chunks = [];
                    let text = addressText.trim();
                    page.drawLine({
                        start: { x: 50, y },
                        end:   { x: 390, y },
                        thickness: 1,
                        dashPhase: 0,
                    });
                    while (text.length > maxLen) {
                        // find the last space before the 45th character
                        let splitIndex = text.lastIndexOf(' ', maxLen);

                        if (splitIndex === -1) {
                        splitIndex = maxLen;
                        }

                        chunks.push(text.slice(0, splitIndex).trim());

                        text = text.slice(splitIndex).trim();
                    }

                    if (text.length) chunks.push(text);

                    chunks.forEach(lineText => {
                        line(" " + lineText);
                    });

                    page.drawLine({
                        start: { x: 50, y: y - 5 },
                        end:   { x: 390, y: y - 5},
                        thickness: 1,
                        dashPhase: 0,
                    });

                    page.drawLine({
                        start: { x: 50, y: y - 5},
                        end:   { x: 50, y: y + lineH * chunks.length },
                        thickness: 1,
                        dashPhase: 0,
                    });

                    page.drawLine({
                        start: { x: 390, y: y - 5 },
                        end:   { x: 390, y: y + lineH * chunks.length },
                        thickness: 1,
                        dashPhase: 0,
                    });

                    // Create PNG barcode
                    const pngBytes = await this.makePdf417PngBytes(id);
                    const img = await pdf.embedPng(pngBytes);

                    const targetW = 150;
                    const scale = targetW / img.width;
                    const drawW = targetW;
                    const drawH = img.height * scale;

                    // If not enough room left on page for the barcode height, move to a new page
                    if (textTopY - drawH - 6 < margin) {
                        page = pdf.addPage();
                        y = page.getHeight() - margin;
                    }

                    // Place barcode to the right
                    const rightX = page.getWidth() - margin - drawW;
                    page.drawImage(img, {
                        x: rightX,
                        y: y - drawH + (lineH * 1.5),
                        width: drawW,
                        height: drawH,
                    });

                    const textY = (y - drawH + (lineH * 1.5)) - 12;
                    page.drawText(`${id}`, {
                        x: rightX + 50,
                        y: textY + 3,
                        size: 10,
                        font
                    });

                    const textBlockH = lineH * 2 + 6;
                    const blockH = Math.max(textBlockH, drawH + 4);
                    y -= Math.max(0, blockH - (lineH * 2));
                    y -= 6;
                }

                y -= 8; // spacing between stops
                const w = page.getWidth();
                page.drawLine({
                    start: { x: 50, y },
                    end:   { x: w - 50, y },
                    thickness: 1,
                    dashPhase: 0,
                });
            }

            // Open in new tab
            const bytes = await pdf.save();
            const blob = new Blob([bytes], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            window.open(url);
        },
        async runFilter(event) {
            await this.filterValues(event);
        },
        async filterValues(event){
            console.log("FILTER")
            this.isFiltered = true;
            this.filterField = event.filterField;
            this.filterValue = event.filterValue;

            switch (event.filterField) {
                case "tripSheetID":
                    this.listTripWaypointsFunc(this.filterValue);
                    this.isFiltered = false;
                    break;
                default:
                    break;
            }
        },
        async listTripWaypointsFunc(tripSheetID) {
            this.loadingData = true;
            this.tripShipments = [];
            let graphqlQuery = `query listTripWaypoints($nextToken: String, $tripSheetID: String) {
                listTripWaypoints(nextToken: $nextToken, tripSheetID: $tripSheetID) {
                    items{
                    tripSheetID
                    stop
                    longitude
                    latitude
                    created
                    startTime
                    endTime
                    route
                    waypoint
                    pickups
                    arrival
                    departure
                    stopType
                    serviceStatus
                    isDelivery
                    windowEnd
                    windowStart
                    locations{
                        address1
                        address2
                        latitude
                        longitude
                        city
                        companyName
                        zipCode
                        state
                    }
                    address{
                        address1
                        address2
                        latitude
                        longitude
                        city
                        companyName
                        zipCode
                        state
                      }
                    shipments{
                        shipmentID
                        isPriority
                        signatureRequired
                        lastActivity{
                            activityTime
                            description
                            code
                        }
                      address{
                        address1
                        address2
                        latitude
                        longitude
                        city
                        companyName
                        zipCode
                        state
                      }
                    }
                }
                    nextToken
                }
            }`;

            try {
                let allTripShipments = [];
                let nextToken = null;

                do {
                    let response = await API.graphql({
                        query: graphqlQuery,
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                        variables: { nextToken, tripSheetID }
                    });

                    const data = response.data.listTripWaypoints;
                    allTripShipments = [...allTripShipments, ...data.items];
                    nextToken = data.nextToken;

                } while (nextToken); 

                this.tripShipments = allTripShipments;
                allTripShipments.sort((a, b) =>  a.stop - b.stop);
                this.tripShipments = allTripShipments;
                this.loadingData = false;
            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting trip shipments.";
                this.loadingData = false;
            }
        },
        formatLocalTime(utcDate) {
            const date = new Date(utcDate);

            const formattedDate = date.toLocaleString('en-US', {
                month: 'numeric',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: true
            });

            return formattedDate;
        },
        formatLocalTimeArrival(time24) {
            const [hours, minutes] = time24.split(":");
            const date = new Date();
            date.setHours(hours, minutes, 0, 0);

            // Format to a readable local 12-hour time
            const localTime = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

            return localTime;
        },
        trackShipment(shipmentID){
            this.toggleTrackShipment = true;
            this.trackShipmentID = shipmentID;
        },
        closeShipmentInfo(event){
            this.toggleTrackShipment = event;
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        async downloadCSVTest(){
            this.loadingTable = true;
            let csvArray;

            csvArray = this.tripShipments.map(obj =>{
                return {
                    shipmentID: obj.shipmentID,
                    route: obj.route,
                    DeliveryCompanyName: obj.address.companyName,
                    DeliveryAddress1: obj.address.address1,
                    DeliveryAddress2: obj.address.address2,
                    DeliveryCity: obj.address.city,
                    DeliveryState: obj.address.state,
                    DeliveryZipCode: obj.address.zipCode,
                    TripSheetID: obj.tripSheetID,
                    Status: obj.status,
                    ExternalTrackingNumber: obj.externalTrackingNumber ?? "ERROR"
                }
            })
            jsonexport(csvArray, (error, csv) => {
                if (error) {
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error downloading manifest shipments"
                }
                const blob = new Blob([csv], { type: 'text/csv' });
                const anchor = document.createElement('a');
                anchor.href = window.URL.createObjectURL(blob);
                anchor.download = 'TripSheetData.csv';
                anchor.click();
                window.URL.revokeObjectURL(anchor.href);
                anchor.remove();
                this.loadingTable = false;
            })
        }
    }
}
</script>

<style scoped>
.table-container-main {
	width: 100%;
	margin-top: 0;
	overflow-x: hidden;
	resize: both;
	height: 350px
}

.responsive-table {
	width: 100%
}

* {
	scrollbar-width: auto;
	scrollbar-color: #f3f3f3 #fff
}

::-webkit-scrollbar {
	width: 16px
}

::-webkit-scrollbar-track {
	background: #fff
}

::-webkit-scrollbar-thumb {
	background-color: #f3f3f3;
	border-radius: 10px;
	border: 3px solid #fff
}

.table-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #32ccfe;
	margin-bottom: 10px;
	padding: 5px;
	border-radius: 5px;
	color: #fff;
	position: sticky;
	top: 0
}

.table-row-container {
	height: 100%;
	overflow-y: auto;
	border-radius: 5px;
	width: 100%;
	animation: animate-table-row 1s ease
}

@keyframes animate-table-row {
	from {
		margin-left: -50px
	}

	to {
		margin-left: 0
	}
}

.table-row {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #f3f3f3;
	margin-bottom: 10px;
	padding: 5px;
	border-radius: 5px
}

.table-header .col-1 {
	margin-right: 5px
}

.col-1 {
	flex-basis: 10%;
	text-align: left;
	white-space: nowrap
}

.col-2 {
	flex-basis: 10%;
	text-align: left;
	margin-left: 5px
}

.col-3 {
	flex-basis: 35%;
	text-align: left;
	margin-left: 5px
}

.col-data {
	text-align: left
}

/* .col-4 {
	flex-basis: 10%;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center
} */
.shipment-status-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    gap: 8px;
    margin-top: 2px;
    margin-bottom: 2px;
}

.shipment-status-container p{
    margin-top: 0;
    margin-bottom: 0;
}

.activity-description{
    margin: 0;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #d4d4d4;
}

.col-4 {
	flex-basis: 45%;
    /* margin-left: auto; */
	display: flex;
	justify-content: flex-start;
	align-items: center;
    flex-wrap: wrap;
    word-break: break-word;
    overflow-wrap: break-word;
}

.col-4 p{
    margin-left: 2px;
    /* font-size: .6rem; */
}

.service-text {
	background-color: #d4d4d4;
	padding: 2.5px 10px;
	border-radius: 999px;
	width: fit-content;
	margin: 0;
	font-size: 12px
}

.shipmentid-text {
	margin: 0;
	color: #6a6a6a;
	width: fit-content;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #f3f3f3;
	border: 1px solid #a0a0a0;
	transition-duration: .5s
}

.shipmentid-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.svg-container-outer{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.svg-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: fit-content;
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    /* flex-basis: 25%; */
    min-width: 65%;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

input[type=checkbox] {
	-webkit-appearance: none;
	appearance: none;
	background-color: #fff;
	margin: 0;
	cursor: pointer;
	font: inherit;
	color: #33f18a;
	width: 1.05em;
	height: 1.05em;
	border: .15em solid #33f18a;
	border-radius: .15em;
	display: grid;
	place-content: center;
	transition-duration: .5s
}

input[type=checkbox]:hover {
	background-color: #f3f3f3;
	transition-duration: .5s
}

input[type=checkbox]::before {
	content: "";
	width: .65em;
	height: .65em;
	clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0, 43% 62%);
	transform: scale(0);
	transform-origin: bottom left;
	transition: 120ms transform ease-in-out;
	box-shadow: inset 1em 1em var(--form-control-color);
	background-color: CanvasText
}

input[type=checkbox]:checked::before {
	transform: scale(1)
}

.button-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	margin: 0;
	animation: animate-table-row 1s ease
}

.print-selected-text {
	margin: 0;
	margin-bottom: 5px;
	margin-right: 5px;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #f3f3f3;
	border: 1px solid #a0a0a0;
	transition-duration: .5s
}

.download-csv {
	margin-top: 5px
}

.void-selected-text {
	margin: 0;
	margin-bottom: 5px;
	padding: 2.5px 10px;
	margin-bottom: 5px;
	border-radius: 999px;
	background-color: #fe804d;
	border: 1px solid #ff5512;
	color: #fff;
	transition-duration: .5s
}

.print-selected-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.void-selected-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.close-label {
	margin-left: auto
}

.label-container {
	width: 100%
}

@media only screen and (max-width:600px) {
	.service-text {
		font-size: 8px
	}

    .svg-container-outer{
        font-size: 10px;
    }
}

@media only screen and (max-width:1135px) {
	.col-1 {
		min-width: 10%
	}
}
</style>